import React, { useCallback, useState, useRef, useEffect } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import "./PageTwo.css";
import { getBlLot } from "../../../Redux/reclamationReduce";
import { useTranslation } from 'react-multi-lang';
import { useDispatch } from "react-redux";

const PageTwo = ({ idClaim, motifSelect, nextPageNumber, onButtonClick, produitSelect, lot, qte, setBl, setCommentaire, getUploadFile, getBl, setUploadFile, getCommentaire ,client}) => {

  const t = useTranslation();

  const dispatch = useDispatch();

  const [commentaire, setCommentaireLocal] = React.useState(getCommentaire);
  const [bl, setBlLocal] = React.useState(getBl);
  const [uploadFile, setUploadFileLocal] = React.useState(getUploadFile);

  function handleUploadFile(event) {

    let blFile = event.target.files[0];
    if (blFile) {
      setUploadFile(blFile);
      setUploadFileLocal(blFile);
    }

  }

  const getBlLotF = useCallback(async (lot, bl, idClaim, produitSelect) => {
    var array = await dispatch(getBlLot({ lot:  lot }));
    var entities = array.payload;
    var newArray = idClaim ? [...bl] : [];
    entities.forEach((blItem) => {
      if (!bl.some((entity) => entity.id === blItem.id)) {
        newArray.push(blItem);
      }
    });

    setBl(newArray);
    setBlLocal(newArray);

  }, [dispatch]);

  useEffect(() => {
    if (motifSelect.value == 1 || motifSelect.value == 3) getBlLotF(lot, bl, idClaim, produitSelect)
  }, [lot]);

  return (
    <main
      className="pt5 black-80 center"
      style={{ maxWidth: "60%", maxHeight: "30%", margin: "auto" }}
    >
      <form className="measure">
        {motifSelect.value == 1 || motifSelect.value == 3 ?
          <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
            <h2 className="text-left font-bold">{t("info_article")}</h2>
            <table className="table table-bordered">
              <thead>
                <tr className="table-info">
                  <th>{t("designation")}</th>
                  <th>{t("Reclamation.numero_lot")}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{produitSelect.label}</td>
                  <td>{lot}</td>
                </tr>
              </tbody>
            </table>
          </fieldset>
          : null}
        <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
          <h2 className="text-left font-bold">{t("ma_reclamation")}</h2>
          {motifSelect.value == 1 || motifSelect.value == 3 ?
            <table className="table table-bordered">
              <thead>
                <tr className="table-info">
                  <th></th>
                  <th>{t("reference_bl")}</th>
                  <th>{t("quantite")}</th>
                  <th>{t("qte_souhaite")}</th>
                  <th>Date expiration</th>
                  <th>{t("date_liv")}</th>
                </tr>
              </thead>
              <tbody>
                {bl.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <Form.Group>
                        <Form.Check>
                          <Form.Check.Label>
                            <Form.Check.Input
                              type="checkbox"
                              checked={item.quantite != undefined ? item.quantite > 0 ? true : false : false}
                              onChange={(v) => {
                                var e = [...bl];
                                e[index].isChecked = v.target.checked;
                                setBl(e);
                                setBlLocal(e);
                              }}
                            ></Form.Check.Input>
                            <span className="form-check-sign"></span>
                            <label></label>
                          </Form.Check.Label>
                        </Form.Check>
                      </Form.Group>
                    </td>
                    <td>{item.NumLivraison}</td>
                    <td>{item.Qte}</td>
                    <td>
                      <Form.Group>
                        <Form.Control
                          value={item.quantite}
                          placeholder="Quantite"
                          type="Number"
                          pattern="\d+"
                          onChange={(value) => {
                            var e = [...bl];
                            e[index].quantite = value.target.value ? parseInt(value.target.value.replace(/[^0-9]/g, '')) : undefined;
                            setBl(e);
                            setBlLocal(e);
                          }}
                        />
                      </Form.Group>
                    </td>
                    <td>
                      {item.DateExpiration}
                    </td>
                    <td>
                      {item.DateLivraison}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table> : null}
          <Row>
            <Col md="12">
              <h2 className="text-left font-bold">     {motifSelect.value == 1 || motifSelect.value == 3 ? t("commentaire") : "Description"}</h2>
              <Form.Group>
                <Form.Control
                  as={"textarea"}
                  placeholder={motifSelect.value == 1 || motifSelect.value == 3 ? t("write_comment") : "Description de la réclamation"}
                  value={commentaire}
                  name="commentaire"
                  onChange={(e) => { setCommentaire(e.target.value); setCommentaireLocal(e.target.value) }}
                  rows="30"
                ></Form.Control>
              </Form.Group>
            </Col>
            <Col md="12">
              <h2 className="text-left font-bold">Piéce jointe</h2>
              <Form.Group >
                <Form.Control
                  id="test"
                  name="file"
                  type="file"
                  onChange={(e) => handleUploadFile(e)}
                ></Form.Control>
              </Form.Group>
            </Col>
          </Row>
        </fieldset>
        <br></br>
        <div >
          <Button
            className="btn-fill pull-right "
            type="button"
            variant="info" onClick={() => onButtonClick("pagetwo")}
          >
            {t("suivant")}
          </Button>

          <Button
            className="btn-fill pull-right  ml-3 mr-3"
            type="button"
            variant="info" onClick={() => motifSelect.value == 3 || motifSelect.value == 1 ? nextPageNumber(1) : nextPageNumber(0)} // Navigate back to page one
          >
            {t("précédent")}
          </Button>
        </div>
      </form>
    </main>
  );
}

export default PageTwo;
